import {Component, OnInit, Inject, Input} from '@angular/core';
import { MdDialog, MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import {Observable} from 'rxjs';
import {PaymentService} from '../../services/payment.service';
import { Order } from '../../models/order';
import { MessageBoxDialog } from '../message-box/message-box.component';
import { PaymentDialogComponent } from '../payment-dialog/payment-dialog.component';
import { JobOffersService } from '../../services/job-offers.service';

@Component({
  selector: 'app-edit-offer-vacancy-dialog',
  templateUrl: './edit-offer-vacancy-dialog.component.html',
  styleUrls: ['./edit-offer-vacancy-dialog.component.css']
})
export class EditOfferVacancyDialogComponent implements OnInit {
  transactions: any;
  totalTransactions: number;
  loading: boolean;
  @Input() jobsOffer: any;
  page: number;
  max: number;
  
  publicating: boolean;
  quantity: number;

  constructor(
    public dialogRef: MdDialogRef<EditOfferVacancyDialogComponent>,
    public dialog: MdDialog,
    public paymentService: PaymentService,
    private jobService: JobOffersService,
  ) {
    this.loading = true;
    this.page = 1;
    this.max = 10;
  }

  ngOnInit() {
    this.searchTransactions();
  }

  searchTransactions (page?: number, query?: string, active?: boolean, deleted?: boolean) {
    this.loading = true;

    this.page = page;
    if (page == null) {
      page = 1;
    }

    const status = 1;
    this.paymentService.getTransaction(page, this.max, status)
    .subscribe(
    data => {
      this.transactions = data.transaction;
      this.totalTransactions = data.pagination.total;
      this.loading = false;
    },
    error => {
      if (error.status == 404) {
        this.transactions = undefined;
        this.totalTransactions = 0;
        this.loading = false;
      } else {
        console.log(error);
        this.transactions = undefined;
        this.totalTransactions = 0;
        this.loading = false;
      }
    });
  }

  openDialogPaymentCredits() {
    let dialogRef = this.dialog.open(PaymentDialogComponent);
    dialogRef.afterClosed().subscribe(result => {
      this.searchTransactions();
    });
  }

  editOfferVacancy() {
    this.jobService.putOffersQuantity(this.jobsOffer.id, this.quantity)
    .subscribe(
      data => {
        this.publicating = false;
        this.dialog.open(MessageBoxDialog, {data: {message: 'Vacantes Agregadas', success: true, showIcon:true}});
        this.searchTransactions();
      },
      error => {
        console.log(error);
        this.dialog.open(MessageBoxDialog, {data: {title: 'No se pudo agregar las Vacantes', alert: true, showIcon:true}});
        this.publicating = false;
      }
    );
  }

  _keyPressNumberPositive(event: any) {
    const pattern = /[0-9\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  getTotalInvitations() {
    let total = 0;
    this.transactions.forEach(element => {
      total += Number(element.order_package.invitation.invitation);
    });
    return total;
  }

}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/edit-offer-vacancy-dialog/edit-offer-vacancy-dialog.component.ts